module.exports = __webpack_public_path__ + "static/img/case6.768f7380.jpg";